import { render, staticRenderFns } from "./AuthorModal.vue?vue&type=template&id=228ba792&scoped=true&"
import script from "./AuthorModal.vue?vue&type=script&lang=js&"
export * from "./AuthorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228ba792",
  null
  
)

export default component.exports